export const CHAT_WIDGET_ID = '6ac01c63cdeb03a6d56c6422';
export const CHAT_NUDGE_DELAY = 8000;
export const CHAT_RETRY_TIMEOUT = 5000;
export const CHAT_NUDGE_KEY = 'taoh-ai-chat-nudge';

type ChatApi = { openWidget: () => void; closeWidget: () => void };
type ChatWindow = Window & { leadConnector?: { chatWidget?: ChatApi }; dataLayer?: unknown[] };

export const chatEnabled = (pathname: string) => !['/content', '/vsl', '/book', '/simulator'].includes(pathname.replace(/\/+$/, ''));

export function loadChatWidget() {
  if (document.querySelector(`script[data-widget-id="${CHAT_WIDGET_ID}"]`)) return;
  const script = document.createElement('script');
  script.src = 'https://widgets.leadconnectorhq.com/loader.js';
  script.dataset.resourcesUrl = 'https://widgets.leadconnectorhq.com/chat-widget/loader.js';
  script.dataset.widgetId = CHAT_WIDGET_ID;
  script.async = true;
  document.head.appendChild(script);
}

export type ChatButtonVariant = 'text' | 'avatar';
export const CHAT_VARIANT_KEY = 'taoh-ai-chat-button-variant';

/** A/B test ended: the avatar won, so the launcher is always the avatar. */
export function getChatButtonVariant(): ChatButtonVariant {
  return 'avatar';
}

export function trackChat(event: string, variant: ChatButtonVariant) {
  const w = window as ChatWindow;
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ event, chat_button_variant: variant, page: window.location.pathname });
}

export async function openAiChat(variant?: ChatButtonVariant): Promise<boolean> {
  const started = Date.now();
  const w = window as ChatWindow;
  while (chatEnabled(window.location.pathname)) {
    const api = w.leadConnector?.chatWidget;
    if (api?.openWidget) {
      api.openWidget();
      w.dataLayer = w.dataLayer || [];
      w.dataLayer.push({ event: 'ai_chat_open', page: window.location.pathname, ...(variant && { chat_button_variant: variant }) });
      return true;
    }
    if (Date.now() - started >= CHAT_RETRY_TIMEOUT) break;
    await new Promise((resolve) => window.setTimeout(resolve, 100));
  }
  return false;
}

export function closeAiChat() {
  (window as ChatWindow).leadConnector?.chatWidget?.closeWidget?.();
}